import React, { useEffect, useCallback } from 'react';
import './style.scoped.css';
import Loading from 'src/components/Loading';
import usePullToRefresh from 'src/hooks/usePullToRefresh';
import PromotionListItem from 'src/components/PromotionListItem';
import Promotion from 'src/models/Promotion';
import homeStore, { HomeStore } from 'src/stores/HomeStore';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

interface PromotionsObserverProps {
  store?: HomeStore;
}
const PromotionsObserver = observer(({ store }: PromotionsObserverProps) => {
  const { t } = useTranslation();
  const _load = useCallback(() => {
    store.fetchAllPromotion();
  }, [store]);

  // Add pull to refresh function
  usePullToRefresh('.refreshContent', <Loading type={'small'} />, _load);

  useEffect(() => {
    _load();
  }, [_load]);

  const _renderItem = (item: Promotion, index) => {
    return (
      <div
        key={item.id}
        className={index < store.allPromotion.length - 1 ? 'mb-4' : ''}
      >
        <PromotionListItem data={item} />
      </div>
    );
  };

  return (
    <div className="roundContent">
      <div className="screenScrollContainerWithTab refreshContent">
        {store.loadingAllPromotion ? (
          <Loading type={'small'} />
        ) : !store.allPromotion || store.allPromotion.length == 0 ? (
          <div className="center p-4 pt-8">
            <div className="text-center text-onSurfaceVariant">
              {t('no_promotion')}
            </div>
          </div>
        ) : (
          store.allPromotion.map(_renderItem)
        )}
      </div>
    </div>
  );
});

const Promotions = () => <PromotionsObserver store={homeStore} />;
export default Promotions;
